<template>
  <div>
    <div id="responsive" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!--          Modal Header -->
          <div class="modal-header" style="text-align: center;">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{trans.pricing}}</h4>
            <div class="label-form " v-if="minPrice && service.cost != '0.00'" >
              <div v-if="service.cost">
                {{ currency_symbol }}{{ service.cost }} {{ unit }}
              </div>
            </div>
            <div v-if="minPrice" class="label-form " >
              {{ minPrice }}
            </div>
            <div v-if="serviceFirstTimeOffer > 0">
              <div class="label-form "  > - {{ serviceFirstTimeOffer }}</div>
              {{ serviceFirstTimeDiscountType_sign }}
            </div>
          </div>
          <!--          End Of Modal Header -->
          <!-- Modal Body -->
          <div class="modal-body" style="padding: 30px !important;">
            <div class="row" >

              <!--  Start Price List View  -->
              <div class="col-xs-12 custom_field_service-item" v-if="rates"  >
                <div class="ibox" style="margin-bottom: 0px; padding: 10px 0px 5px 0px;">
                  <div class="ibox-title" data-toggle="collapse" data-target="#priceListViewInsideModal" style="border-width: 0px !important; background-color: inherit; cursor: pointer; text-align: center;">
                    <h4 style="float: left;">{{ trans.price_ranges}}</h4>
                    <span style="float: right; font-size: 20px;" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
                  </div>
                  <div class="ibox-content collapse in" id="priceListViewInsideModal" style=" background-color: inherit;">
                    <div class="col-xs-12 price-list-modal" >
                        <service-view-right-menu-price-list_rates
                            :service="service" :currency="currency" :rates="rates" :unit="unit"
                        ></service-view-right-menu-price-list_rates>
                    </div>
                  </div>
                </div>
              </div>
              <!--  End  Price List View  -->

              <!--  start  Service Discount  -->
              <div class="col-xs-12 custom_field_service-item"  v-if="serviceDiscounts.length != 0 "  >
                <div class="ibox" style="margin-bottom: 0px; padding: 10px 0px 5px 0px;">
                  <div class="ibox-title" data-toggle="collapse" data-target="#serviceDiscountsInsideModal" style="border-width: 0px !important; background-color: inherit; cursor: pointer; text-align: center;">
                    <h4 style="float: left;">{{ trans.discount_offers }}</h4>
                    <span style="float: right; font-size: 20px;" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
                  </div>
                  <div class="ibox-content collapse in" id="serviceDiscountsInsideModal" style=" background-color: inherit;">
                    <div class="col-xs-12 price-list-modal">
                      <div class="price-row" style="text-align: unset;" v-for="(serviceDiscount, index ) in serviceDiscounts" :key="index" >
                        <div class="row">
                          <div class="col-min_pricexs-12"  >
                            <div class="col-xs-9 text-left">
                              {{ serviceDiscount.min_size_range }} - {{ serviceDiscount.max_size_range }} {{ unit}}
                            </div>
                            <div class="col-xs-3 text-left">
                              {{ currency_symbol }}{{ serviceDiscount.price_with_discount }} {{ per }} {{ unit }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  End  Service Discount  -->

              <!--  start  Attributes Section  -->
              <div v-if="attributes">
                <div class="col-xs-12 custom_field_service-item" v-for="(attribute, index ) in attributes" :key="index"   >
                  <div class="ibox" style="margin-bottom: 0px; padding: 10px 0px 5px 0px;">
                    <div class="ibox-title" data-toggle="collapse" :data-target="'#attributeInsideModal_' + attribute.attribute_id" style="border-width: 0px !important; background-color: inherit; cursor: pointer; text-align: center;">
                      <span style="float: right; font-size: 20px;" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
                      <h4 style="float: left;">{{ attribute.attribute_name }}</h4>
                    </div>
                    <div class="ibox-content collapse in" :id="'attributeInsideModal_' + attribute.attribute_id" style=" background-color: inherit;">
                      <div class="col-xs-12 price-list-modal" >
                        <div v-if="attribute.attributeValuesPriceList">
                          <div v-for="(attributeValuePriceList, index ) in attribute.attributeValuesPriceList" :key="index" class="price-row">
                            <div class="row">
                                <div class="col-xs-9 text-left">
                                  {{ attributeValuePriceList.attribute_value }}</div>
                                <div class="col-xs-3 text-left">{{ currency_symbol }}{{ attributeValuePriceList.total_price }}</div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--  End  Attributes Section  -->
            </div>
            <!-- start Modal footer -->
            <div class="modal-footer">
              <button type="button" data-dismiss="modal" class="btn default">{{trans.close}}</button>
            </div>
            <!-- End Modal footer -->
          </div>
          <!-- End Modal Body -->

        </div>
      </div>
    </div>

  </div>
</template>


<script>


import ServiceViewRightMenuPriceList_rates from "./ServiceViewRightMenuPriceList_rates";
export default {
  name: "ServiceViewRightMenuPriceList_modal",
  components: {ServiceViewRightMenuPriceList_rates},
  props: [
    'trans',
    'serviceFirstTimeDiscountType_sign',
    'serviceFirstTimeOffer',
    'unit',
    'min_size_range',
    'per',
    'currency_symbol',
    'serviceDiscounts',
    'websiteSettings',
    'attributes',
    'minPrice',
    // 'pricinglistView',
    'service',
    'currency',
    'rates',
  ],
  data() {
    return {

    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
  }
}
</script>

